import moment from "moment"
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import {
  addVital,
  getVitals,
} from "../../core/services/api/patientDiagnosisService"
import { MocUserRole } from "../../core/services/models/Enums"
import Button from "../Button"
import InputField from "../InputField"
import vitalUnit from "./vitalUnit.json"

interface VitalsDataType {
  [key: string]: string
}
export default function VitalsView({
  setResVitalData,
  setHeightFunc,
  setIsVitalData,
  setIpdErrors,
  setAllDetails,
  setBeyondRange,
  setBeyondLimit,
  setMandatoryFields,
  getVitalsPayload,
  resVitalData,
  patientDetail,
  isReadOnly,
  recordDetails,
  appointmentDetails,
  scroll
}: any) {

  const centerId = appointmentDetails?.centerId
  const consultantId = appointmentDetails?.consultantId
  const appointmentId = appointmentDetails?.id
  const appointmentType = appointmentDetails?.appointmentType
  const recordId = recordDetails?.id
  const patientId = appointmentDetails?.patientId
  const userRole = useSelector((state: any) => state?.user?.role)

  const [VitalsData, setVitalsData] = useState<VitalsDataType>({
    Height: "",
    Weight: "",
    BSA: "0",
    BMI: "0",
    Temperature: "",
    BP: "",
    Pulse: "",
    SPO2: "",
    Haemoglobin: "",
    "Total WBC Count": "",
    "Platelets Count": "",
    "Absolute Neutrophil Count (ANC)": "",
    "Total Bilirubin": "",
    "Serum Bilirubin Direct": "",
    "Serum Bilirubin Indirect": "",
    "SGOT (AST)": "",
    "ALT (SGPT)": "",
    "Total Protein": "",
    Albumin: "",
    Globulin: "",
    "AG Ratio": "",
    "Alkaline Phosphatase": "",
    GGT: "",
    "Serum Creatinine": "",
    BUN: "",
    Urea: "",
    "Uric Acid": "",
    Sodium: "",
    Potassium: "",
    Chloride: "",
    "S.Calcium": "",
    LDH: "",
    "eGFR- Creat Clearance": "",
    "HGT-mg/dl": "",
  })
  const mandatoryFields = [
    "Height",
    "Weight",
    "Temperature",
    "BP",
    "Pulse",
    "SPO2"
  ]
  const ipdMandatoryFields = [
    "Height",
    "Weight",
    "Temperature",
    "BP",
    "Pulse",
    "SPO2",
    "Haemoglobin",
    "Total WBC Count",
    "Platelets Count",
    "Absolute Neutrophil Count (ANC)",
    "Serum Creatinine",
    "eGFR- Creat Clearance",
    "HGT-mg/dl"
  ]
  const [formVitalErrors, setFormVitalErrors] = useState<VitalsDataType>({})

  const [isVitalSubmit, setIsVitalSubmit] = useState(false)
  const [VitalsBp, setVitalsBp] = useState({ "BP Systolic": "", 'BP Diastolic': "" })
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const calculateBmiAndBsa = () => {
    if (!(VitalsData.Height === "0" && VitalsData.Weight === "0")) {
      if (
        !(isNaN(Number(VitalsData.Height)) && isNaN(Number(VitalsData.Weight)))
      ) {
        let bmi =
          Number(VitalsData.Weight) /
          Math.pow(Number(VitalsData.Height) / 100, 2)

        bmi = isNaN(bmi) ? 0 : Math.round((bmi + Number.EPSILON) * 100) / 100
        const tempBSA =
          (Number(VitalsData.Height) * Number(VitalsData.Weight)) / 3600
        let bsa = Math.sqrt(tempBSA)
        bsa = Math.round((bsa + Number.EPSILON) * 100) / 100
        setVitalsData({
          ...VitalsData,
          BMI: bmi.toString(),
          BSA: bsa.toString(),
        })
      }
    }
  }

  const calculateCreatClearance = () => {
    if ((VitalsData.Weight !== "" && VitalsData["Serum Creatinine"] !== "")) {
      if ((Number(VitalsData.Weight) !== 0 && Number(VitalsData["Serum Creatinine"]) !== 0 && Number(patientDetail?.age) !== 0)) {
        let creatClearance =
          ((140 - Number(patientDetail?.age)) * (Number(VitalsData.Weight))) / (72 * Number(VitalsData["Serum Creatinine"]))
        let finalCreatClearance
        let temp = Math.round(creatClearance)
        if (patientDetail?.gender === "Male") {
          finalCreatClearance = temp
        } else {
          finalCreatClearance = Math.round(Number(temp) * 0.85)
        }
        setVitalsData({
          ...VitalsData,
          "eGFR- Creat Clearance": finalCreatClearance.toString(),
        })
      } else if (patientDetail?.age === 0) {
        setVitalsData({
          ...VitalsData,
          "eGFR- Creat Clearance": "N/A",
        })
      }
    }
  }

  useEffect(() => {
    if (scroll) {
      scroll()
    }
  }, [])

  useEffect(() => {
    // setIsLoading(true)
    getVitals(recordId)
      .then((data) => {
        const res = data.data
        const { height, weight, bsa, bmi, temperature, pulseInfo, spo2, hemoglobin, wbcCount, plateletsCount, anc, serumCreatinine, egfr, totalBilirubinDirect, sgot, sgpt, salbumin, totalProtein, scalcium, hgt, serumBilirubinDirect, serumBilirubinInDirect, globulin, agRatio, alkalinePhosphate, ggt, bun, urea, uricAcid, sodium, potassium, chloride, ldh } = res
        const temp = {
          ...VitalsData, ...{
            Height: height,
            Weight: weight,
            BSA: bsa,
            BMI: bmi,
            Temperature: temperature,
            Pulse: pulseInfo,
            SPO2: spo2,
            Haemoglobin: hemoglobin,
            "Total WBC Count": wbcCount,
            "Platelets Count": plateletsCount,
            "Absolute Neutrophil Count (ANC)": anc,
            "Serum Creatinine": serumCreatinine,
            "eGFR- Creat Clearance": egfr,
            "Total Bilirubin": totalBilirubinDirect,
            "SGOT (AST)": sgot,
            "ALT (SGPT)": sgpt,
            Albumin: salbumin,
            "Total Protein": totalProtein,
            "S.Calcium": scalcium,
            "HGT-mg/dl": hgt,
            "Serum Bilirubin Direct": serumBilirubinDirect,
            "Serum Bilirubin Indirect": serumBilirubinInDirect,
            Globulin: globulin,
            "AG Ratio": agRatio,
            "Alkaline Phosphatase": alkalinePhosphate,
            GGT: ggt,
            BUN: bun,
            Urea: urea,
            "Uric Acid": uricAcid,
            Sodium: sodium,
            Potassium: potassium,
            Chloride: chloride,
            LDH: ldh,
          }
        }
        if (height) {
          setHeightFunc(height)
        }
        setVitalsData(temp)
        setVitalsBp({ ...VitalsBp, ...{ 'BP Systolic': res?.bpSystolic, 'BP Diastolic': res?.bpDiastolic } })
        const result = validateVitals(temp)
        delete result?.errors
        setFormVitalErrors(result)
        setIsLoading(false)
      })
      .catch((err) => {
        console.log(err)
        setIsLoading(false)
      })
  }, [appointmentId, recordId])

  useEffect(() => {
    calculateBmiAndBsa()
  }, [VitalsData.Height, VitalsData.Weight])

  useEffect(() => {
    calculateCreatClearance()
  }, [VitalsData.Weight, VitalsData["Serum Creatinine"], patientDetail?.age])

  useEffect(() => {
    // if (scroll) {
    //   scroll()
    // }
    let isAllMandatoryFilled = true
    const isIPD = appointmentType === "IPD"
    if (isIPD) {
      ipdMandatoryFields.forEach((ele: any) => {
        if (ele === "BP") {
          if (VitalsBp?.["BP Systolic"] === "" || VitalsBp?.["BP Diastolic"] === "" || VitalsBp?.["BP Systolic"] === null || VitalsBp?.["BP Diastolic"] === null) {
            isAllMandatoryFilled = false
          }
        } else {
          if (VitalsData[`${ele}`] === "" || VitalsData[`${ele}`] === null) {
            isAllMandatoryFilled = false
          }
        }
      })
    } else {
      mandatoryFields.forEach((ele: any) => {
        if (ele === "BP") {
          if (VitalsBp?.["BP Systolic"] === "" || VitalsBp?.["BP Diastolic"] === "" || VitalsBp?.["BP Systolic"] === null || VitalsBp?.["BP Diastolic"] === null) {
            isAllMandatoryFilled = false
          }
        } else {
          if (VitalsData[`${ele}`] === "" || VitalsData[`${ele}`] === null) {
            isAllMandatoryFilled = false
          }
        }
      })
    }
    if (!isAllMandatoryFilled && isVitalSubmit) {
      //Enter all the mandatory fields to prcoeed further
      setIsVitalSubmit(false)
      setMandatoryFields(true)
    } else {
      if (
        !(
          formVitalErrors?.errors &&
          Object.keys(formVitalErrors.errors).length > 0
        ) &&
        isVitalSubmit
      ) {
        if (
          formVitalErrors?.color &&
          Object.keys(formVitalErrors.color).length > 0 &&
          isVitalSubmit
        ) {
          getVitalsPayload({
            VitalsData: VitalsData,
            VitalsBp: VitalsBp,
            errors: formVitalErrors,
          })
          if (
            userRole === MocUserRole.CONSULTANT
          ) {
            setBeyondLimit(true)
          } else {
            setBeyondRange(true)
          }
          setIsVitalSubmit(false)
        } else if (
          formVitalErrors?.bold &&
          Object.keys(formVitalErrors.bold).length > 0 &&
          isVitalSubmit
        ) {
          getVitalsPayload({
            VitalsData: VitalsData,
            VitalsBp: VitalsBp,
          })
          setBeyondLimit(true)
          setIsVitalSubmit(false)
        } else if (
          formVitalErrors?.errors &&
          Object.keys(formVitalErrors.bold).length === 0 &&
          Object.keys(formVitalErrors.color).length === 0 &&
          Object.keys(formVitalErrors.errors).length === 0 &&
          isVitalSubmit
        ) {
          const tempObj = { ...VitalsData }
          delete tempObj.BSA
          delete tempObj.BMI
          delete tempObj.BP
          const values = Object.entries(tempObj)
          const bool = values.some((v: any) => v[1] == "")
          if (bool) {
            getVitalsPayload({
              VitalsData: VitalsData,
              VitalsBp: VitalsBp,
            })
            setAllDetails(true)
          } else {
            getVitalsPayload({
              VitalsData: VitalsData,
              VitalsBp: VitalsBp,
            })
            // setIsLoading(true)
            addVital(
              {
                ...VitalsData,
                vitalCaptureDate: appointmentDetails?.scheduleDate,
                bpSystolic: VitalsBp["BP Systolic"],
                bpDiastolic: VitalsBp["BP Diastolic"],
              },
              { centerId, consultantId, patientId, appointmentId, recordId }
            )
              .then((data) => {
                setIsLoading(false)
                setResVitalData(data)
                setIsVitalData(true)
                setHeightFunc(data.height)
              })
              .catch((err) => {
                setIsLoading(false)
                console.log(err)
              })
          }
        }
      }
    }
  }, [formVitalErrors])

  const validateVitals = (values: any) => {
    const errors: any = {}
    const bold: any = {}
    const color: any = {}

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/
    const isIPD = appointmentType === "IPD"
    // drpodown validation
    if (!values.Pulse) {
      errors.Pulse = "Pulse is required"
    } else if (
      (values.Pulse !== "" && values.Pulse !== null) &&
      ((values.Pulse >= 100 && values.Pulse <= 120) ||
        (values.Pulse >= 40 && values.Pulse <= 60))
    ) {
      bold.Pulse = true
    } else if (
      ((values.Pulse !== "" && values.Pulse !== null) &&
        (values.Pulse >= 120 || values.Pulse <= 40) || values.Pulse?.toLowerCase() === "na")
    ) {
      color.Pulse = true
    }
    if (!values.Height) {
      errors.Height = "Height is required"
    } else if (
      (values.Height !== "" && values?.Height !== null) &&
      ((values.Height >= 205 && values.Height < 210) || values.Height <= 139)
    ) {
      bold.Height = true
    } else if ((values.Height !== "" && values?.Height !== null) && (values.Height >= 210 || values.Height?.toLowerCase() === "na")) {
      color.Height = true
    }
    if (!values.Weight) {
      errors.Weight = "Weight is required"
    } else if (
      (values.Weight !== "" && values?.Weight !== null) &&
      values.Weight >= 130 &&
      values.Weight < 200
    ) {
      bold.Weight = true
    } else if ((values.Weight !== "" && values?.Weight !== null) && (values.Weight >= 200 || values?.Weight?.toLowerCase() === "na")) {
      color.Weight = true
    }
    if (!values.Temperature) {
      errors.Temperature = "Temperature is required"
    } else if (
      (values.Temperature !== "" && values?.Temperature !== null) &&
      values.Temperature >= 99 &&
      values.Temperature < 110
    ) {
      bold.Temperature = true
    } else if ((values.Temperature !== "" && values?.Temperature !== null) && (values.Temperature >= 110 || values?.Temperature?.toLowerCase() === "na")) {
      color.Temperature = true
    }
    if (Object.keys(VitalsBp).length > 0) {
      if (!VitalsBp?.["BP Systolic"]) {
        errors["BP Systolic"] = "Systolic BP is required"
      }
      if (!VitalsBp?.["BP Diastolic"]) {
        errors["BP Diastolic"] = "Diastolic BP is required"
      }
      if (VitalsBp?.["BP Systolic"]) {
        if (Number(VitalsBp["BP Systolic"]) > 140 && Number(VitalsBp["BP Systolic"]) < 200) {
          bold["BP Systolic"] = true
        } else if ((Number(VitalsBp["BP Systolic"]) < 90 || Number(VitalsBp["BP Systolic"]) >= 200) || VitalsBp["BP Systolic"]?.toLowerCase() === "na") {
          color["BP Systolic"] = true
        }
      }
      if (VitalsBp?.["BP Diastolic"]) {
        if (Number(VitalsBp["BP Diastolic"]) > 50 && Number(VitalsBp["BP Diastolic"]) < 60) {
          bold["BP Diastolic"] = true
        } else if ((Number(VitalsBp["BP Diastolic"]) <= 50 || Number(VitalsBp["BP Diastolic"]) >= 90) || VitalsBp["BP Diastolic"]?.toLowerCase() === "na") {
          color["BP Diastolic"] = true
        }
      }
    }
    if (!values.SPO2) {
      errors.SPO2 = "SPO2 is required"
    } else if ((values.SPO2 !== "" && values.SPO2 !== null) && values.SPO2 >= 90 && values.SPO2 < 92) {
      bold.SPO2 = true
    } else if ((values.SPO2 !== "" && values.SPO2 !== null) && ((values.SPO2 > 100 || values.SPO2 < 90) || values.SPO2?.toLowerCase() === "na")) {
      color.SPO2 = true
    }
    if (!values.Haemoglobin && isIPD) {
      errors.Haemoglobin = "Haemoglobin is required"
    } else if (patientDetail?.gender === "Male") {
      if (
        (values.Haemoglobin !== "" && values.Haemoglobin !== null) &&
        values.Haemoglobin >= 8 &&
        values.Haemoglobin <= 14
      ) {
        bold.Haemoglobin = true
      } else if (
        (values.Haemoglobin !== "" && values.Haemoglobin !== null) &&
        ((values.Haemoglobin > 18 || values.Haemoglobin < 8) || values.Haemoglobin?.toLowerCase() === "na")
      ) {
        color.Haemoglobin = true
      }
    } else if (patientDetail?.gender === "Female") {
      if (
        (values.Haemoglobin !== "" && values.Haemoglobin !== null) &&
        ((values.Haemoglobin >= 8 && values.Haemoglobin <= 12.5) ||
          (values.Haemoglobin >= 16.5 && values.Haemoglobin <= 18))
      ) {
        bold.Haemoglobin = true
      } else if (
        (values.Haemoglobin !== "" && values.Haemoglobin !== null) &&
        ((values.Haemoglobin > 18 || values.Haemoglobin < 8) || values.Haemoglobin?.toLowerCase() === "na")
      ) {
        color.Haemoglobin = true
      }
    }
    if (!values["Total WBC Count"] && isIPD) {
      errors["Total WBC Count"] = "Total WBC Count is required"
    } else if (
      (values["Total WBC Count"] !== "" && values["Total WBC Count"] !== null) &&
      ((values["Total WBC Count"] > 3000 && values["Total WBC Count"] < 4000) ||
        (values["Total WBC Count"] > 10000 &&
          values["Total WBC Count"] < 20000))
    ) {
      bold["Total WBC Count"] = true
    } else if (
      (values["Total WBC Count"] !== "" && values["Total WBC Count"] !== null) &&
      ((values["Total WBC Count"] < 3000 || values["Total WBC Count"] > 20000) || values["Total WBC Count"]?.toLowerCase() === "na")
    ) {
      color["Total WBC Count"] = true
    }
    if (!values["Absolute Neutrophil Count (ANC)"] && isIPD) {
      errors["Absolute Neutrophil Count (ANC)"] =
        "Absolute Neutrophil Count (ANC) is required"
    } else if (
      (values["Absolute Neutrophil Count (ANC)"] !== "" && values["Absolute Neutrophil Count (ANC)"] !== null) &&
      ((values["Absolute Neutrophil Count (ANC)"] < 1500 ||
        values["Absolute Neutrophil Count (ANC)"] > 6000) || values["Absolute Neutrophil Count (ANC)"]?.toLowerCase() === "na")
    ) {
      color["Absolute Neutrophil Count (ANC)"] = true
    }
    if (!values["Platelets Count"] && isIPD) {
      errors["Platelets Count"] = "Platelets Count is required"
    } else if (
      (values["Platelets Count"] !== "" && values["Platelets Count"] !== null) &&
      ((values["Platelets Count"] > 100 && values["Platelets Count"] < 150) ||
        (values["Platelets Count"] > 400 && values["Platelets Count"] < 600))
    ) {
      bold["Platelets Count"] = true
    } else if (
      (values["Platelets Count"] !== "" && values["Platelets Count"] !== null) &&
      ((values["Platelets Count"] < 100 || values["Platelets Count"] > 600) || values["Platelets Count"]?.toLowerCase() === "na")
    ) {
      color["Platelets Count"] = true
    }
    if (!values["Serum Creatinine"] && isIPD) {
      errors["Serum Creatinine"] = "Serum Creatinine is required"
    } else if (
      (values["Serum Creatinine"] !== "" && values["Serum Creatinine"] !== null) &&
      values["Serum Creatinine"] > 1.1 &&
      values["Serum Creatinine"] < 2
    ) {
      bold["Serum Creatinine"] = true
    } else if (
      (values["Serum Creatinine"] !== "" && values["Serum Creatinine"] !== null) &&
      ((values["Serum Creatinine"] > 2 || values["Serum Creatinine"] < 0.6) || values["Serum Creatinine"]?.toLowerCase() === "na")
    ) {
      color["Serum Creatinine"] = true
    }
    if (!values["eGFR- Creat Clearance"] && isIPD) {
      errors["eGFR- Creat Clearance"] = "eGFR- Creat Clearance is required"
    } else if (
      (values["eGFR- Creat Clearance"] !== "" && values["eGFR- Creat Clearance"] !== null) &&
      ((values["eGFR- Creat Clearance"] > 30 &&
        values["eGFR- Creat Clearance"] < 60) ||
        (values["eGFR- Creat Clearance"] > 130 &&
          values["eGFR- Creat Clearance"] < 400))
    ) {
      bold["eGFR- Creat Clearance"] = true
    } else if (
      (values["eGFR- Creat Clearance"] !== "" && values["eGFR- Creat Clearance"] !== null) &&
      ((values["eGFR- Creat Clearance"] < 30 ||
        values["eGFR- Creat Clearance"] > 400) || values["eGFR- Creat Clearance"]?.toLowerCase() === "na")
    ) {
      color["eGFR- Creat Clearance"] = true
    }
    if (
      (values["Total Bilirubin"] !== "" && values["Total Bilirubin"] !== null) &&
      values["Total Bilirubin"] > 1.2 &&
      values["Total Bilirubin"] < 10
    ) {
      bold["Total Bilirubin"] = true
    } else if (
      (values["Total Bilirubin"] !== "" && values["Total Bilirubin"] !== null) &&
      (values["Total Bilirubin"] > 10 || values["Total Bilirubin"]?.toLowerCase() === "na")
    ) {
      color["Total Bilirubin"] = true
    }
    // if (!values["Serum Bilirubin Direct"]) {
    //   errors["Serum Bilirubin Direct"] = "Serum Bilirubin Direct is required"
    // } else
    if (
      (values["Serum Bilirubin Direct"] !== "" && values["Serum Bilirubin Direct"] !== null) &&
      values["Serum Bilirubin Direct"] > 0.4 &&
      values["Serum Bilirubin Direct"] < 0.1
    ) {
      bold["Serum Bilirubin Direct"] = true
    } else if (values["Serum Bilirubin Direct"]?.toLowerCase() === "na") {
      color["Serum Bilirubin Direct"] = true
    }
    if (values["Serum Bilirubin Indirect"]?.toLowerCase() === "na") {
      color["Serum Bilirubin Indirect"] = true
    }
    if (
      (values["ALT (SGPT)"] !== "" && values["ALT (SGPT)"] !== null) &&
      values["ALT (SGPT)"] > 44 &&
      values["ALT (SGPT)"] < 180
    ) {
      bold["ALT (SGPT)"] = true
    } else if ((values["ALT (SGPT)"] !== "" && values["ALT (SGPT)"] !== null) && (values["ALT (SGPT)"] > 180 || values["ALT (SGPT)"]?.toLowerCase() === "na")) {
      color["ALT (SGPT)"] = true
    }
    if (
      (values["SGOT (AST)"] !== "" && values["SGOT (AST)"] !== null) &&
      ((values["SGOT (AST)"] > 38 && values["SGOT (AST)"] < 150) ||
        values["SGOT (AST)"] < 8)
    ) {
      bold["SGOT (AST)"] = true
    } else if ((values["SGOT (AST)"] !== "" && values["SGOT (AST)"] !== null) && (values["SGOT (AST)"] > 150 || values["SGOT (AST)"]?.toLowerCase() === "na")) {
      color["SGOT (AST)"] = true
    }
    if (
      ((values["Total Protein"] !== "" && values["Total Protein"] !== null) &&
        values["Total Protein"] > 5 &&
        values["Total Protein"] < 6.7) ||
      values["Total Protein"] > 8.3
    ) {
      bold["Total Protein"] = true
    } else if ((values["Total Protein"] !== "" && values["Total Protein"] !== null) && (values["Total Protein"] < 5 || values["Total Protein"]?.toLowerCase() === "na")) {
      color["Total Protein"] = true
    }
    if (
      ((values["Albumin"] !== "" && values["Albumin"] !== null) &&
        values["Albumin"] > 2 &&
        values["Albumin"] < 3.8) ||
      values["Albumin"] > 5
    ) {
      bold["Albumin"] = true
    } else if ((values["Albumin"] !== "" && values["Albumin"] !== null) && (values["Albumin"] < 2 || values["Albumin"]?.toLowerCase() === "na")) {
      color["Albumin"] = true
    }
    if (
      (values["S.Calcium"] !== "" && values["S.Calcium"] !== null) &&
      ((values["S.Calcium"] > 7 && values["S.Calcium"] < 8.4) ||
        (values["S.Calcium"] > 10.2 && values["S.Calcium"] < 14))
    ) {
      bold["S.Calcium"] = true
    } else if (
      (values["S.Calcium"] !== "" && values["S.Calcium"] !== null) &&
      ((values["S.Calcium"] < 7 || values["S.Calcium"] > 14) || values["S.Calcium"]?.toLowerCase() === "na")
    ) {
      color["S.Calcium"] = true
    }
    if (!values["HGT-mg/dl"] && isIPD) {
      errors["HGT-mg/dl"] = "HGT-mg/dl is required"
    } else if (
      (values["HGT-mg/dl"] !== "" && values["HGT-mg/dl"] !== null) &&
      ((values["HGT-mg/dl"] > 40 && values["HGT-mg/dl"] < 80) ||
        (values["HGT-mg/dl"] > 140 && values["HGT-mg/dl"] < 300))
    ) {
      bold["HGT-mg/dl"] = true
    } else if (
      (values["HGT-mg/dl"] !== "" && values["HGT-mg/dl"] !== null) &&
      ((values["HGT-mg/dl"] < 40 || values["HGT-mg/dl"] > 300) || values["HGT-mg/dl"].toLowerCase() === "na")
    ) {
      color["HGT-mg/dl"] = true
    }
    if (
      (values.Globulin !== "" && values.Globulin !== null) &&
      (values.Globulin < 2.9 || values.Globulin > 3.3)
    ) {
      bold.Globulin = true
    } else if (values?.Globulin?.toLowerCase() === "na") {
      color.Globulin = true
    }
    if (
      (values["AG Ratio"] !== "" && values["AG Ratio"] !== null) &&
      (values["AG Ratio"] < 1.3 || values["AG Ratio"] > 2.5)
    ) {
      bold["AG Ratio"] = true
    } else if (values["AG Ratio"]?.toLowerCase() === "na") {
      color["AG Ratio"] = true
    }
    if (
      (values["Alkaline Phosphatase"] !== "" && values["Alkaline Phosphatase"] !== null) &&
      (values["Alkaline Phosphatase"] < 33 ||
        values["Alkaline Phosphatase"] > 111)
    ) {
      bold["Alkaline Phosphatase"] = true
    } else if (values["Alkaline Phosphatase"]?.toLowerCase() === "na") {
      color["Alkaline Phosphatase"] = true
    }
    if ((values.GGT !== "" && values.GGT !== null) && (values.GGT < 16 || values.GGT > 73)) {
      bold.GGT = true
    } else if (values.GGT?.toLowerCase() === "na") {
      color.GGT = true
    }
    if ((values.BUN !== "" && values.BUN !== null) && (values.BUN < 8 || values.BUN > 23)) {
      bold.BUN = true
    } else if (values.BUN?.toLowerCase() === "na") {
      color.BUN = true
    }
    if ((values.Urea !== "" && values.Urea !== null) && (values.Urea < 15 || values.Urea > 40)) {
      bold.Urea = true
    } else if (values.Urea?.toLowerCase() === "na") {
      color.Urea = true
    }
    if (
      (values["Uric Acid"] !== "" && values["Uric Acid"] !== null) &&
      (values["Uric Acid"] < 3 || values["Uric Acid"] > 5.5)
    ) {
      bold["Uric Acid"] = true
    } else if (values["Uric Acid"]?.toLowerCase() === "na") {
      color["Uric Acid"] = true
    }
    if ((values.Sodium !== "" && values.Sodium !== null) && (values.Sodium < 136 || values.Sodium > 149)) {
      bold.Sodium = true
    } else if (values.Sodium?.toLowerCase() === "na") {
      color.Sodium = true
    }
    if (
      (values.Potassium !== "" && values.Potassium !== null) &&
      (values.Potassium < 3.8 || values.Potassium > 5)
    ) {
      bold.Potassium = true
    } else if (values.Potassium?.toLowerCase() === "na") {
      color.Potassium = true
    }
    if ((values.Chloride !== "" && values.Chloride !== null) && (values.Chloride < 96 || values.Chloride > 108)) {
      bold.Chloride = true
    } else if (values.Chloride?.toLowerCase() === "na") {
      color.Chloride = true
    }
    if ((values.LDH !== "" && values.LDH !== null) && (values.LDH < 106 || values.LDH > 211)) {
      bold.LDH = true
    } else if (values.LDH?.toLowerCase() === "na") {
      color.LDH = true
    }
    const vitalsMetaData: any = { errors, bold, color }
    return vitalsMetaData
  }

  const handleVitalSubmit = (e: any) => {
    if (userRole !== MocUserRole.FRONT_DESK) {
      e.preventDefault()
      setFormVitalErrors(validateVitals(VitalsData))
      setIsVitalSubmit(true)
    }
  }

  function validate() {
    const res = validateVitals(VitalsData)
    // delete res?.errors
    setFormVitalErrors(res)
  }

  return (
    <>
      {
        isLoading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "50%",
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div >
        )
      }
      <form onSubmit={handleVitalSubmit}>
        <div>
          <div className="heading">Vitals</div>
          <div className="current-date">
            <img
              src="../../assets/images/datepickerIcon.svg"
              alt=""
              height={30}
              width={30}
            />
            <div>{moment(appointmentDetails?.scheduleDate)?.format("DD-MM-YYYY")}</div>
          </div>
          <div className="vital-content">
            <div className="vital-row row">

              {Object.keys(VitalsData).map((item: any, i) => {
                const isIPD: any = appointmentType === "IPD"
                const value: string = VitalsData[item]
                return (
                  <><div className="col-3 col-md-3 mb-4">
                    <div className="label label_margin">{`${isIPD ? ipdMandatoryFields?.includes(item) ? "*" : "" : mandatoryFields?.includes(item) ? "*" : ""} ${item}`}:</div>
                    {item === "BP" ? (
                      <div className="smaller-input">
                        <InputField
                          value={VitalsBp["BP Systolic"]}
                          handleChange={(e) => {
                            setVitalsBp({ ...VitalsBp, 'BP Systolic': e.target.value })
                          }}
                          errorMsg={formVitalErrors?.errors && formVitalErrors?.errors[item && "BP Systolic"]}
                          readOnly={isReadOnly}
                          className={formVitalErrors?.color && formVitalErrors.color[item && "BP Systolic"]
                            ? "red-text"
                            : formVitalErrors?.bold && formVitalErrors.bold[item && "BP Systolic"]
                              ? "bold-text"
                              : ""}
                          handleBlur={() =>
                          // setFormVitalErrors(validateVitals(VitalsData))
                          {
                            (userRole !== MocUserRole.FRONT_DESK && !isReadOnly) &&
                              validate()
                          }

                          }
                        />
                        /
                        <InputField
                          value={VitalsBp["BP Diastolic"]}
                          handleChange={(e) => {
                            setVitalsBp({ ...VitalsBp, 'BP Diastolic': e.target.value })
                          }}
                          readOnly={isReadOnly}
                          errorMsg={formVitalErrors?.errors && formVitalErrors?.errors[item && "BP Diastolic"]}
                          className={formVitalErrors?.color && formVitalErrors.color[item && "BP Diastolic"]
                            ? "red-text"
                            : formVitalErrors?.bold && formVitalErrors.bold[item && "BP Diastolic"]
                              ? "bold-text"
                              : ""}
                          handleBlur={() =>
                          // setFormVitalErrors(validateVitals(VitalsData))
                          {
                            (userRole !== MocUserRole.FRONT_DESK && !isReadOnly) &&
                              validate()
                          }

                          }
                        />
                      </div>
                    ) : (
                      <div>
                        <InputField
                          value={value}
                          handleChange={(e) => {
                            setVitalsData({
                              ...VitalsData,
                              [item]: e.target.value,
                            })
                          }}
                          readOnly={(item === "BSA" || item === "BMI" || item === "eGFR- Creat Clearance" ? true : false) ||
                            isReadOnly}
                          errorMsg={formVitalErrors?.errors && formVitalErrors.errors[item]}
                          className={formVitalErrors?.color && formVitalErrors.color[item]
                            ? "red-text"
                            : formVitalErrors?.bold && formVitalErrors.bold[item]
                              ? "bold-text"
                              : ""}
                          handleBlur={() =>
                          // setFormVitalErrors(validateVitals(VitalsData))
                          {
                            (userRole !== MocUserRole.FRONT_DESK && !isReadOnly) &&
                              validate()
                          }

                          } />
                      </div>
                    )}
                  </div><div className="col-1 units">&nbsp;{vitalUnit[i]}</div></>
                )
              })}
            </div>
            <div className="vital-submit">
              {isReadOnly ? "" : <Button text="Save Vitals" id="save-vitals" type="submit"></Button>}
            </div>
          </div>
        </div >
      </form >
    </>
  )
}
